import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface LocationTypeChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LocationTypeChangeModal: React.FC<LocationTypeChangeModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "oceanWeatherIntelligence.operationRuleLocation",
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="newBlue.500" fontSize="lg" fontWeight={600}>
          {t("areaEventEditing")}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text color="gray.600" fontSize="md" lineHeight="1.5">
            {t("changePointToAreaWarning")}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            mr={3}
            onClick={onClose}
            color="newBlue.500"
            _hover={{ bg: "gray.100" }}
          >
            {t("cancel")}
          </Button>
          <Button
            layerStyle="ocean"
            _hover={{ layerStyle: "ocean" }}
            onClick={onConfirm}
          >
            {t("yesIWantToContinue")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LocationTypeChangeModal;
